export const TRANSLATION_LANGUAGES = [
  { code: "nl", label: "NL" },
  { code: "fr", label: "FR" },
  { code: "de", label: "DE" },
  { code: "en", label: "EN" },
  { code: "cs", label: "CS" },
];

export const TranslationRowType = Object.freeze({
  FLOW: "FLOW",
  NODE: "NODE",
  OPTION: "OPTION",
});

export const TranslationField = Object.freeze({
  NAME: "name",
  INFORMATION: "information",
  LABEL: "label",
  PROMPT: "prompt",
  OPTION: "option",
});

export const TRANSLATION_FIELD_LIMITS = Object.freeze({
  name: 256,
  label: 256,
  prompt: 1024,
  information: 2048,
  option: 256,
});
